export default [

    {
        path: '',
        name: 'encartes-virtuais',
        redirect: { name: 'encartes-virtuais-home' },
    },

    {
        path: 'home',
        name: 'encartes-virtuais-home',
        component: () => import('@/aplicacao/modulos/encartes-virtuais/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_VIRTUAL' },
    },

    {
        path: 'formulario/:id?',
        name: 'encartes-virtuais-formulario',
        component: () => import('@/aplicacao/modulos/encartes-virtuais/formulario/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_VIRTUAL_SOLICITAR' },
    },

    {
        path: 'formulario/:id/sucesso',
        name: 'encartes-virtuais-sucesso',
        component: () => import('@/aplicacao/modulos/encartes-virtuais/formulario/Sucesso'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_VIRTUAL_SOLICITAR' },
    },

    {
        path: 'historico',
        name: 'encartes-virtuais-historico',
        component: () => import('@/aplicacao/modulos/encartes-virtuais/Historico'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_VIRTUAL' },
    },

    {
        path: 'pendencias',
        name: 'encartes-virtuais-pendencias',
        component: () => import('@/aplicacao/modulos/encartes-virtuais/Pendencias'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_VIRTUAL_PENDENCIAS' },
    },

    {
        path: 'rascunhos',
        name: 'encartes-virtuais-rascunhos',
        component: () => import('@/aplicacao/modulos/encartes-virtuais/Rascunhos'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_VIRTUAL_SOLICITAR' },
    },

    {
        path: ':id',
        name: 'encartes-virtuais-fluxo',
        component: () => import('@/aplicacao/modulos/encartes-virtuais/fluxo/Fluxo'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_VIRTUAL' },
    },

    {
        path: 'relatorios/geral',
        name: 'encartes-virtuais-relatorios-geral',
        component: () => import('@/aplicacao/modulos/encartes-virtuais/relatorios/Geral'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_VIRTUAL_RELATORIO_GERAL' },
    },

    {
        path: 'relatorios/ranking-sku',
        name: 'encartes-virtuais-relatorios-ranking-sku',
        component: () => import('@/aplicacao/modulos/encartes-virtuais/relatorios/RankingSku'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_VIRTUAL_RELATORIO_RANKING_SKU' },
    },

    {
        path: 'relatorios/veiculacao',
        name: 'encartes-virtuais-relatorios-veiculacao',
        component: () => import('@/aplicacao/modulos/encartes-virtuais/relatorios/Veiculacao'),
        meta: { autenticacao: true, permissao: 'ROLE_ENCARTE_VIRTUAL_RELATORIO_VEICULACAO' },
    },

]
